// extracted by mini-css-extract-plugin
module.exports = {"row":"ExternalAuthorList_row__2MNMg","actions":"ExternalAuthorList_actions__3_A9m"};